import React from "react";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { useProductGroupList } from "../../../api/product-group/use-product-group";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import { useSetState } from "../../../utils/hooks";
import BannerProductTable from "./BannerProductTable";

const options = [
  { id: "category", name: "카테고리" },
  { id: "productGroupName", name: "상품 그룹명" },
];

const BannerProductLinkage = ({ handleSelectProduct }) => {
  const [filter, dispatchFilter] = useSetState({
    check_by: "category",
  });
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const { data: productList } = useProductGroupList(selectedFilter);

  const handleResetSearch = () => {
    setSelectedFilter({});
    dispatchFilter({});
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const { category, productGroupName, check_by } = filter;
    if (check_by === "productGroupName") {
      setSelectedFilter({
        [check_by]: productGroupName,
      });
    } else {
      setSelectedFilter({
        [check_by]: category,
      });
    }
  };

  return (
    <div className="px-6">
      <FieldBox unSplittedWidth="w-[20%]" label="상품검색" isLast>
        <div className="flex gap-3 justify-between">
          <Dropdown
            width="w-48"
            options={options}
            height="h-8"
            positionDropdown={`top-12`}
            placeholder="카테고리"
            textColor="text-black px-4"
            onClickItem={(value) => dispatchFilter({ check_by: value })}
          />
          <form className="flex" onSubmit={handleSearch}>
            <input
              type="search"
              className={`w-[230px] h-8 text-black border-l border-t border-b border-button-grey rounded-l-[4px] p-2 focus:outline-0`}
              placeholder="필터 선택 후,  검색"
              onChange={(e) =>
                dispatchFilter({ [filter?.check_by]: e.target.value })
              }
              // value={filter?.productGroupName}
            />
            <button
              type="submit"
              className="cursor-pointer h-8 flex items-center bg-[#19459f] px-4 py-2 border-r border-[#19459f] rounded-r-[4px]"
            >
              <HiMagnifyingGlass className="text-white text-[18px] m-auto" />
            </button>
          </form>
          <Button
            text="검색 초기화"
            margin="mr-0"
            disabledTextColor="text-white"
            borderColor="border-[#cccccc] border"
            onClick={handleResetSearch}
          />
        </div>
      </FieldBox>
      <div className="mt-3">
        <BannerProductTable
          handleSelectProduct={handleSelectProduct}
          productList={productList?.items}
        />
      </div>
    </div>
  );
};

export default BannerProductLinkage;
